import React, { useEffect, memo, useState } from 'react';
import { createPortal } from 'react-dom';
import { useSelector, useDispatch } from 'react-redux';
import { __ } from '@wordpress/i18n';
import { queryNavigation, queryParamDelete } from '../utils/query-navigation';
import './style.scss';
import SiteFiltersCombined from '../site-filters-combined';
import ICONS from '../icons';
const directoryUrl = AstraShowcaseVars.directoryUrl;

const DirectorySearchFilter = () => {
	const { showDirectoryFilters, searchTerm } = useSelector( ( state ) => state );
	const dispatch = useDispatch();
	const [ query, setQuery ] = useState( searchTerm );
	const [ noResult, setNoResult ] = useState( false );
	const [ ajaxStatus, setAjaxStatus ] = useState( false );
	const [ suggestions, setSuggestions ] = useState( [] );

	const fetchSuggestions = async ( inputValue ) => {
		try {
			const directorySearch = new FormData();
			directorySearch.append( 'action', 'astra-sites-directory-search' );
			directorySearch.append(
				'_ajax_nonce',
				AstraShowcaseVars._ajax_nonce
			);
			directorySearch.append( 'input_value', inputValue );

			const response = await fetch( AstraShowcaseVars.ajaxurl, {
				method: 'post',
				body: directorySearch,
			} );
			const data = await response.json();
			if ( data.data.length === 0 ) {
				setNoResult( true );
			}
			setSuggestions( data.data );
			setAjaxStatus( true );
		} catch ( error ) {
			return false;
		}
	};

	const handleInputChange = ( event ) => {
		const { value } = event.target;
		dispatch( {
			type: 'set',
			searchTerm: '',
		} );
		setQuery( value );
	};

	useEffect( () => {
		const delay = setTimeout( () => {
			if ( query.trim().length === 0 ) {
				setSuggestions( [] );
				setAjaxStatus( false );
				return;
			}
			if ( searchTerm === '' ) {
				fetchSuggestions( query );
			}
		}, 300 ); // Adjust the debounce delay as needed.

		if ( query === '' ) {
			queryParamDelete( 'search' );
			dispatch( {
				type: 'set',
				searchTerm: '',
			} );
		} else {
			queryNavigation(
				'search',
				query
			);
			dispatch( {
				type: 'set',
				searchTerm: query,
			} );
		}
		return () => clearTimeout( delay );
	}, [ query ] );

	const handleCrossIconClick = ( event ) => {
		event.preventDefault();
		setQuery( '' );
		setSuggestions( [] );
		setAjaxStatus( false );
	};

	const handleToggleOutsideClick = ( event ) => {
		if ( ! event.target.classList.contains( 'stc-search-input' ) ) {
			setAjaxStatus( false );
			setSuggestions( [] );
		}
	};

	const handleKeyPress = ( event ) => {
		if ( event.key === 'Enter' && query.trim().length > 0 ) {
			// Update the URL when Enter key is pressed
			window.location.replace( location.pathname + '?search=' + query );
		}
	};

	useEffect( () => {
		document
			.querySelector( 'body' )
			.addEventListener( 'click', handleToggleOutsideClick );

		return () =>
			document
				.querySelector( 'body' )
				.removeEventListener( 'click', handleToggleOutsideClick );
	}, [] );

	return showDirectoryFilters
		? createPortal(
			<>
				<div
					id="directory-search-filter"
					className={ `directory-search-filter ${
						query ? 'directory-search-filter-active' : ''
					}` }
				>
					<div className="st-search-box search-form">
						<div
							className={ `stc-search ${
								query ? 'stc-search-have-input' : ''
							}` }
						>
							<button className="stc-search-icon">
								{ ICONS.search }
							</button>
							<button
								className="stc-cross-icon"
								onClick={ handleCrossIconClick }
							>
								{ ICONS.cross }
							</button>
							<input
								type="text"
								className="stc-search-input"
								value={ query }
								onChange={ handleInputChange }
								onKeyDown={ handleKeyPress }
								placeholder={ __(
									'Search for templates',
									'stra-sites-showcase'
								) }
							/>
						</div>
						{ /* Suggestions box */ }
						<div className="astra-sites-directory-autocomplete-result">
							<ul
								className={ `result-list ${
									! ajaxStatus
										? 'have-not-result-list'
										: ''
								}` }
							>
								{ suggestions.length === 0 &&
									query.length > 0 &&
									noResult && (
									<li className="no-result-found">
										{ __(
											'No result found..',
											'astra-sites-showcase'
										) }
									</li>
								) }
								{ suggestions.map( ( suggestion, index ) =>
									suggestion.cat === 'yes' ? (
										<li key={ index }>
											<a href={ suggestion.link }>
												{ suggestion.name }{ ' ' }
												<span>
													{ __(
														'Category',
														'astra-sites-showcase'
													) }
												</span>
											</a>
										</li>
									) : (
										<li key={ index }>
											<a
												href={
													directoryUrl +
														'/?search=' +
														suggestion.slug
												}
											>
												{ suggestion.name }
											</a>
										</li>
									)
								) }
							</ul>
						</div>
						{ /* Suggestions box */ }
					</div>
					<div
						id="st-showcase-type-order-filter"
						className="st-type-and-order-filters"
					>
						<SiteFiltersCombined
							crossIconClick={ handleCrossIconClick } />
					</div>
				</div>
			</>,
			document.getElementById( 'astra-sites-directory-search-box' )
		)
		: null;
};

export default memo( DirectorySearchFilter );
